import { styled } from '@mui/material/styles';

const RING_GRADIENT = 'linear-gradient(45deg, #f9ce34, #ee2a7b, #6228d7)';

const Ring = styled('span', { shouldForwardProp: p => p !== 'size' })(({ size }) => ({
    width: size,
    height: size,
    padding: Math.max(1.5, Math.round(size * 0.09)),
    borderRadius: '50%',
    background: RING_GRADIENT,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    flexShrink: 0,
}));

const Inner = styled('span')({
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    backgroundColor: '#fff',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 1,
    boxSizing: 'border-box',
    overflow: 'hidden',
    '& svg, & img': { width: '100%', height: '100%', display: 'block' },
});

const StoryRingIcon = ({ size = 18, children }) => (
    <Ring size={size}>
        <Inner>{children}</Inner>
    </Ring>
);

export default StoryRingIcon;
